import configuration from '../../utilities/configuration';
import * as EffectUtility from "../../utilities/EffectUtility";
import { BaseModel } from 'sjs-base-model';
import BusinessPartnerModel from '../../models/businessPartner/BusinessPartnerModel';
import { IBusinessPartner } from '../../views/components/BusinessPartnersTextField/BusinessPartnersTextField';

// contract types
export async function requestAllBusinessPartners() {
    const endpoint = configuration.apiServer + configuration.apiBusinessPartnersPath;
    return EffectUtility.getToModel(BusinessPartnerModel, endpoint);
}

export async function addOrEditBusinessPartner(bpId: number, businessPartner: IBusinessPartner) {
    const endpoint = configuration.apiServer + configuration.apiBusinessPartnersPath + "/" + bpId;
    return EffectUtility.putToModel(BaseModel, endpoint, businessPartner, true, true);
}

export async function importBusinessPartners(businessPartners: IBusinessPartner[]) {
    const endpoint = configuration.apiServer + configuration.apiBusinessPartnersPath;
    return EffectUtility.putToModel(BaseModel, endpoint, businessPartners, true, true);
}

export async function deleteBusinessPartner(id) {
    const endpoint = configuration.apiServer + configuration.apiBusinessPartnersPath + "/" + id;
    return EffectUtility.deleteToModel(BaseModel, endpoint);
}
